import React from 'react';

import Money from 'components/Money';

import './styles.css';

const Total = ({total}) => {
  return (
    <div className="Total">
      <div className="section">
        <div className="header">Total</div>
        <div className="value">
          <Money amount={total} />
        </div>
      </div>
    </div>
  );
};

export default Total;
